import { isTextSelection } from '@tiptap/core'
import CodeBlock from '@tiptap/extension-code-block'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import { Editor } from '@tiptap/react'

import { AiBlock } from '@/extensions/AiBlock'
import { FocusMark } from '@/extensions/Focus'

// import { UploadImage } from '@/extensions/UploadImage'

export const isTableGripSelected = (node: HTMLElement) => {
  let container = node

  while (container && !['TD', 'TH'].includes(container.tagName)) {
    container = container.parentElement!
  }

  const gripColumn =
    container &&
    container.querySelector &&
    container.querySelector('a.grip-column.selected')
  const gripRow =
    container &&
    container.querySelector &&
    container.querySelector('a.grip-row.selected')

  if (gripColumn || gripRow) {
    return true
  }

  return false
}

export const isCustomNodeSelected = (editor: Editor, node: HTMLElement) => {
  const customNodes = [
    AiBlock.name,
    FocusMark.name,
    HorizontalRule.name,
    // UploadImage.name,
    CodeBlock.name,
    Image.name,
    Link.name,
  ]

  return (
    customNodes.some((type) => editor.isActive(type)) ||
    isTableGripSelected(node)
  )
}

export const isTextSelected = ({ editor }: { editor: Editor }) => {
  const {
    state: {
      doc,
      selection,
      selection: { empty, from, to },
    },
  } = editor

  // sometimes checking for `empty` is not enough;
  // doubleclicking an empty paragraph returns a node size of 2,
  // so we also check for an empty text size
  const isEmptyTextBlock =
    !doc.textBetween(from, to).length && isTextSelection(selection)

  if (empty || isEmptyTextBlock || !editor.isEditable) {
    return false
  }

  return true
}
